import { useEffect, useState } from "react";
import RouteManager, { PAGE_ROUTES } from "../../../../managers/RouteManager";
import { FEDERAL_FREQUENCY, STATE_FORM_ROUTES } from "../../ReportsConstants";
import {
  DKLabel,
  DKLine,
  DKInput,
  INPUT_TYPE,
  INPUT_VIEW_DIRECTION,
  DKButton,
  DKIcons,
  showToast,
  TOAST_TYPE,
  DKIcon,
  DKTooltipWrapper,
} from "deskera-ui-library";
import { getCPFYears } from "../../../../managers/common/CommonUtil";
import Utility, { deepClone } from "../../../../utility/Utility";
import ReportService from "../../../../services/ReportService";
import moment from "moment"
import { DATE_FORMAT } from "../../../../constants/Constant";
import { saveAs } from "file-saver";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import ic_arrow_back from "../../../../assets/icons/ic_arrow_back.svg";
import ReactTooltip from "react-tooltip";

const DefaultForm = (props) => {
  const isDetails = props?.location?.state?.details? true: false;
  const [formDetails, setFormDetails] = useState(isDetails ? props.location.state.details : {});
  const [formValues, setFormValues] = useState({});
  const [isYear, setYearConfig] = useState(false);
  const [isQuarter, setQuarterConfig] = useState(false);
  const [isUser, setUserConfig] = useState(false);
  const [yearOptions, setYears] = useState(getCPFYears());
  const [quarterOptions, setQuarterOptions] = useState(FEDERAL_FREQUENCY);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    RouteManager.setPresenter({props});
    prepareComponentData();
  }, []);

  const prepareComponentData = () => {
    const isYearEnabled = formDetails.year ? true : false;
    const isQuarterEnabled = formDetails.quarter ? true : false;
    const isUserEnabled = formDetails.employees ? true : false;
    setYearConfig(isYearEnabled);
    setQuarterConfig(isQuarterEnabled);
    setUserConfig(isUserEnabled);
  };

  const onValueChange = (value, field) => {
    switch(field) {
      case "Quarter" :
        formValues[field] = value;
        setQuarterAccountDetails(value.id, formValues["Year"]);
        break;
      case "Year":
        formValues[field] = value;
        setQuarterAccountDetails(formValues["Quarter"], value);
        break
      default:
        formValues[field] = value;
    }
  }

  const setQuarterAccountDetails = (month, inputSelectedYear) => {
    if (month != undefined && !Utility.isEmpty(month.toString()) && !Utility.isEmpty(inputSelectedYear)) {
      let year = parseInt(inputSelectedYear);
      let startDate = moment()
        .month(month)
        .year(year)
        .startOf("quarter")
        .format(DATE_FORMAT.YYYYMMDD);
      let endDate = moment()
        .month(month)
        .year(year)
        .endOf("quarter")
        .format(DATE_FORMAT.YYYYMMDD);
      setStartDate(startDate);
      setEndDate(endDate);
    }
  }

  const getParameters = () => {
    let params = {};
    if(isYear) {
      params["year"] = formValues["Year"];
    }
    if(isQuarter) {
      params["fromDate"] = startDate;
      params["toDate"] = endDate;
    }
    return params;
  }

  const exportForm = () => {
    const formFields = deepClone(formDetails);
    if (isYear && Utility.isEmpty(formValues["Year"])) {
      setFormDetails(formFields);
      return;
    } else if(isQuarter && Utility.isEmpty(formValues["Quarter"])) {
      setFormDetails(formFields);
      return;
    } else if (isUser && Utility.isEmpty(formValues["Employee"])) {
      setFormDetails(formFields);
      return;
    };
    let fileName = `${TenantService.get(TENANT.FIRST_NAME)}_${TenantService.get(
      TENANT.LAST_NAME
    )} ${formDetails.id}.pdf`;
    const parameters = getParameters();
    ReportService.downloadStateForm(
      formDetails.id,
      parameters
    ).then(
      (response) => {
        if (response["size"] <= 0) {
          showToast("Form download failed. Please make sure Tax details are filled and Payrun(s) are processed.", TOAST_TYPE.FAILURE);
        } else {
        saveAs(response, fileName);
        }
      },
      (error) => {
        showToast("Internal Server Error", TOAST_TYPE.FAILURE);
      }
    );

  }

  const routeToReport = () => {
    RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST)
  }

  const renderFormData = () => {
    return (
      <>
        <div className="parent-width">
          <div className="d-flex align-items-center">
            <div
              onClick={() => routeToReport()}
            >
              <DKTooltipWrapper
                content="Back to Report list"
                tooltipClassName="warning-tooltip-prop"
              >
                <DKIcon src={ic_arrow_back} className="ic-s mr-r cursor-hand" />
              </DKTooltipWrapper>
            </div>
            <DKLabel text={formDetails.name} className="fw-m fs-l" />
          </div>
          <div className="bg-white pb-l card-shadow mt-l">
            <DKLabel text={formDetails.description} className="fw-m fs-l p-l" />
            <DKLine className="bg-gray3" />
            <div className="d-flex p-h-l ">
              {isYear && (
                <div className="pr-l" style={{ width: "35%" }}>
                  <DKInput
                    title="Year"
                    value={formValues["Year"]} // Value should be complete string
                    formatter={(obj) => { // How to render selected value from strig of Array
                      return obj;
                    }}
                    type={INPUT_TYPE.DROPDOWN}
                    required={true}
                    canValidate={true}
                    readOnly={false}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    options={yearOptions}
                    errorMessage="Please select year"
                    onChange={(value) => {
                      onValueChange(value, "Year");
                    }}
                    dropdownConfig={{
                      className: "",
                      style: {},
                      allowSearch: false,
                      searchableKey: undefined,
                      data: yearOptions,
                      renderer: (index, obj) => { // How to render dropdwon options from string of array
                        return <DKLabel className="" text={obj} />;
                      },
                      onSelect: (index, value) => {},
                    }}
                  />
                </div>
              )}
              {isQuarter && (
                <div className="pr-l" style={{ width: "35%" }}>
                  <DKInput
                    title="Quarter"
                    value={formValues["Quarter"]} //Complete Object
                    formatter={(obj) => { //How to render a selected option in case of object
                      return obj.value;
                    }}
                    type={INPUT_TYPE.DROPDOWN}
                    required={true}
                    canValidate={true}
                    readOnly={false}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    options={quarterOptions}
                    errorMessage="Please select quarter"
                    onChange={(value) => {
                      // onValueChange(value.id, "Quarter");
                    }}
                    dropdownConfig={{
                      className: "",
                      style: {},
                      allowSearch: false,
                      searchableKey: "name",
                      data: quarterOptions,
                      renderer: (index, obj) => { //How to render value in Dropdown in case of object
                        return <DKLabel text={`${obj.value}`} />;
                      },
                      onSelect: (index, obj) => {
                        onValueChange(obj, "Quarter");
                      },
                    }}
                  />
                </div>
              )}
              <div className={`mb-xs mr-l`} style={{ marginTop: "25px" }}>
                <DKButton
                  title="DOWNLOAD FORM"
                  icon={DKIcons.white.ic_download}
                  className={`bg-app text-white ml-l`}
                  onClick={() => {
                    exportForm();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );

  }

  return (
    <>
      <div className="parent-width">{isDetails && renderFormData()}</div>
    </>
  );
};

export default DefaultForm;
